import { render, staticRenderFns } from "./OffersProductsTable.vue?vue&type=template&id=15daca6c&scoped=true"
import script from "./OffersProductsTable.vue?vue&type=script&lang=js"
export * from "./OffersProductsTable.vue?vue&type=script&lang=js"
import style0 from "./OffersProductsTable.vue?vue&type=style&index=0&id=15daca6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15daca6c",
  null
  
)

export default component.exports